import { Entry, BaseModel, Form, } from '@ngx-resource-toolkit/core';

@Form({

})

export class ObjetLight extends BaseModel {
    constructor(data?) {
        super();
        if (!data) {
            data = {};
        }
        Object.assign(this, data);
    }

    @Entry({
        base: {
            hidden: true
        },
    })
    _explicitType: string = 'ObjetLight';

    @Entry({
        base: {
            hidden: true
        },
    })
    id: number;

    @Entry({

    })
    libelle: string;

    @Entry({

    })
    typeObjet: string;

}



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/objetLight/models/ObjetLight.ts